import React from 'react';

const ITEMS = [
  ['Paneer Butter Masala', '280'],
  ['Dal Makhani',          '180'],
  ['Garlic Naan x3',       '120'],
  ['Mango Lassi x2',       '140'],
  ['Raita',                 '60'],
];

export default function PhoneMockup() {
  return (
    <div className="phone">
      <div className="pscreen">
        <div className="psb">
          <span>9:41 AM</span>
          <span>●●● 5G 🔋</span>
        </div>
        <div className="pah">
          <div className="pah-t"><img src="/assets/totalpe-lockup-transparent-white-660x160.png" alt="TotalPe" style={{height: '20px', width: 'auto', marginRight: '4px'}}/></div>
          <div className="pah-s">Table 4 · Dine-in</div>
        </div>
        <div style={{ flex:1, overflow:'hidden' }}>
          {ITEMS.map(([name, price]) => (
            <div className="pbrow" key={name}>
              <span className="pbi">{name}</span>
              <span className="pbp">₹{price}</span>
            </div>
          ))}
          <div style={{ display:'flex',justifyContent:'space-between',padding:'5px 12px' }}>
            <span style={{ fontSize:8, color:'#9CA3AF' }}>GST @5%</span>
            <span style={{ fontSize:8, color:'#9CA3AF' }}>₹39</span>
          </div>
        </div>
        <div className="ptrow">
          <span className="ptl">TOTAL Bill</span>
          <span className="pta">₹819</span>
        </div>
        <div className="ppbtn">🖨️ Save & Print</div>
        <div className="pqr">
          <div className="pqrbox" style={{ backgroundImage: 'url(/assets/totalpe-icon-mark-256.png)', backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}/>
          <div className="pqrt">
            <div>Vijay Kumar</div>
            <div>+91-9808909898</div>
            <div style={{ color:'#10B981', fontWeight:700 }}>Customer Details</div>
          </div>
        </div>
      </div>
    </div>
  );
}